
const defaultAttrs = {"width":"1024","height":"1024","version":"1.1","viewBox":"0 0 1024 1024"};
const svgInner = "<path fill=\"currentColor\" d=\"M512.003 42.675c259.205 0 469.332 210.128 469.332 469.333S771.208 981.343 512.003 981.343c-259.206 0-469.334-210.13-469.334-469.335S252.797 42.675 512.003 42.675m-64 341.333c0-23.562-19.103-42.665-42.668-42.665s-42.668 19.103-42.668 42.665v256c0 23.565 19.103 42.668 42.668 42.668s42.668-19.103 42.668-42.668zm213.332 0c0-23.562-19.103-42.665-42.668-42.665-23.562 0-42.665 19.103-42.665 42.665v256c0 23.565 19.103 42.668 42.665 42.668 23.565 0 42.668-19.103 42.668-42.668z\"/>";

export default function PauseCircleSvg(props = {}) {
  const className = props.className || props.class;
  const viewBox = defaultAttrs.viewBox;

  let attrs = 'xmlns="http://www.w3.org/2000/svg"';
  if (viewBox) attrs += ' viewBox="' + viewBox + '"';
  if (className) attrs += ' class="' + className + '"';
  if (props.width !== undefined) attrs += ' width="' + props.width + '"';
  if (props.height !== undefined) attrs += ' height="' + props.height + '"';

  return '<svg ' + attrs + '>' + svgInner + '</svg>';
}
